"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2533],{

/***/ 92533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55760);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24899);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88751);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96301);
/* harmony import */ var _components_Default_Teaser_v1_analytics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81873);











const Action = (props)=>{
    const { primaryCTA ="" , secondaryCTA ="" , playVideoCTA ="" , videoTitle ="" , mainTitle ="" , link ="" , text ="" , newTab ="" , urlRef ="" , id ="" , pageType ="" , linkAll ="" , componentPosition =null , eventName =null , eventAction =null , dataLayerLinkType ="".concat(pageType, ":").concat(mainTitle) , productCategory =null , productCollectionsName =null , productRoom =null , propertiesPageType ="" , playVideoCTAcb =()=>"" , index =0 , activeIndex =0 , setActive =()=>"" , item , bannerIndex =-1 , generalConfigData ={}  } = props;
    const { scroll , findAPro , installationServices  } = _constants__WEBPACK_IMPORTED_MODULE_9__.DEFAULT_SCROLL;
    const shortLink = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getShortenedUrlwithGeneral)(link, generalConfigData);
    const [general, setGeneral] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(generalConfigData);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { isAuth  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_7__/* .selectAuthState */ ._9);
    const { pageType: datalayerPageType  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__.selectGenericState);
    const [actionLink, setActionLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(shortLink);
    const [target, setTarget] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [loginRegisterCallback, setLoginRegisterCallback] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (loginRegisterCallback && isAuth && router.pathname.includes(_constants__WEBPACK_IMPORTED_MODULE_9__.MY_ACCOUNT_PATH)) {
            handleOnLinkClick(loginRegisterCallback);
        }
    }, [
        loginRegisterCallback,
        isAuth
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(generalConfigData)) {
            (0,_constants_config__WEBPACK_IMPORTED_MODULE_5__/* .getConfig */ .i)().then(async (config)=>{
                setGeneral(config === null || config === void 0 ? void 0 : config.general);
            });
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(generalConfigData)) {
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(link) && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(general)) {
                const actLink = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getShortenedUrlwithGeneral)(link, general);
                setActionLink(actLink);
            }
        }
    }, [
        link,
        general
    ]);
    const handleLogin = (e)=>{
        if (router.pathname.includes(_constants__WEBPACK_IMPORTED_MODULE_9__.MY_ACCOUNT_PATH)) {
            e.preventDefault();
            e.stopPropagation();
            window.loginRegisterCallback = ()=>{
                setLoginRegisterCallback(e);
                if (actionLink) router.push(actionLink);
            };
            dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_7__/* .setAuthModalVisibility */ .LY)({
                show: true
            }));
        } else {
            handleOnLinkClick();
        }
    };
    const handleOnLinkClick = (event)=>{
        return propertiesPageType === "modalWindow" && playVideoCTA ? playVideoCTAcb(event) : undefined;
    };
    const handleOnClick = (event)=>{
        var ref;
        var ref1;
        const actionLink = (ref1 = event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.getAttribute("href")) !== null && ref1 !== void 0 ? ref1 : "";
        if (actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#KPN")) {
            event.preventDefault();
            event.stopPropagation();
            const link1 = actionLink.split("::");
            const id = link1[0];
            const url = link1[1];
            if (link1) {
                dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_7__/* .setHideCustomerSignupCTA */ .n$)(true));
                if (id === null || id === void 0 ? void 0 : id.includes("signIn")) {
                    window.KPNSignIn = true;
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.isAuthenticated)(url, 0, true);
                } else if (id === null || id === void 0 ? void 0 : id.includes("createAccount")) {
                    window.KPNSignIn = false;
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.isAuthenticated)(url, 1, true);
                } else {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.isAuthenticated)(url);
                }
            }
        }
        const currentIndex = Number(event.target.getAttribute("data-index")) || 0;
        const componentInfo = event.target.getAttribute("data-gbh-component");
        setActive(currentIndex);
        if (event.target.getAttribute("href").startsWith("#") && Object.values(_constants__WEBPACK_IMPORTED_MODULE_9__.MORE_OPTIONS).includes(event.target.text)) {
            exploreMoreScroll(event);
        } else if (router.pathname.includes(_constants__WEBPACK_IMPORTED_MODULE_9__.MY_ACCOUNT_PATH) && !isAuth) {
            handleLogin(event);
        } else {
            handleOnLinkClick(event);
        }
        (0,_components_Default_Teaser_v1_analytics__WEBPACK_IMPORTED_MODULE_10__/* .addTeaserActionAnalytics */ .tP)({
            pageType,
            componentPosition,
            videoTitle,
            link,
            text,
            eventName,
            dataLayerLinkType,
            eventAction,
            productCategory,
            productCollectionsName,
            productRoom,
            datalayerPageType,
            mainTitle,
            componentInfo
        });
    };
    // global explore more scroll
    const exploreMoreScroll = (e)=>{
        e.preventDefault();
        const hash = e.target.hash;
        if (hash === "") return;
        const element = document.querySelector(hash);
        if (!element) return;
        const offsetTop = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getOffsetTop)(element) - (hash === _constants__WEBPACK_IMPORTED_MODULE_9__.FIND_A_PRO_HASH ? findAPro : hash === _constants__WEBPACK_IMPORTED_MODULE_9__.INSTALLATION_SERVICES_HASH ? installationServices : scroll);
        window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
        });
    };
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (newTab === false || newTab === "false") {
            setTarget("_self");
        } else {
            setTarget("_blank");
        }
    }, [
        newTab
    ]);
    const getComponentMessage = function() {
        let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if (message && bannerIndex > -1) {
            const obj = JSON.parse(message);
            obj.componentInfo.componentMessage = "".concat(obj.componentInfo.componentMessage).concat(bannerIndex + 1);
            return JSON.stringify(obj);
        }
    };
    if (!linkAll) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "cmp-teaser__action-link ".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.convertStringToBoolean)(primaryCTA) ? "gbh-primary-button " : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.convertStringToBoolean)(secondaryCTA) ? "gbh-secondary-button " : "").concat(propertiesPageType === "modalWindow" && playVideoCTA ? "video-play-button " : "", " ").concat(index === activeIndex ? "active" : ""),
            role: actionLink ? "link" : "button",
            "aria-describedby": id,
            href: actionLink,
            "aria-label": text,
            target: target,
            rel: urlRef ? "noreferrer" : "",
            onClick: handleOnClick,
            "data-index": index,
            "data-gbh-component": getComponentMessage(item === null || item === void 0 ? void 0 : item.componentInfos),
            children: text
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "cmp-teaser__action-link ".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.convertStringToBoolean)(primaryCTA) ? "gbh-primary-button " : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.convertStringToBoolean)(secondaryCTA) ? "gbh-secondary-button " : "").concat(pageType === "modalWindow" && playVideoCTA ? "video-play-button " : ""),
        role: "button",
        "aria-describedby": id || "",
        rel: urlRef ? "noreferrer" : "",
        "aria-label": text,
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Action);


/***/ }),

/***/ 81873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FS": function() { return /* binding */ getDownloadEventInfo; },
/* harmony export */   "Kb": function() { return /* binding */ addTeaserDescriptionAnalytic; },
/* harmony export */   "Rj": function() { return /* binding */ getTitleEventInfo; },
/* harmony export */   "_V": function() { return /* binding */ addTeaserAnalytic; },
/* harmony export */   "ht": function() { return /* binding */ addDatalayerShare; },
/* harmony export */   "s_": function() { return /* binding */ addTeaserLinkAnalytics; },
/* harmony export */   "tP": function() { return /* binding */ addTeaserActionAnalytics; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; }
/* harmony export */ });
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49139);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20558);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);




const getEventInfo = function() {
    let pageType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", mainTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventLabel = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", eventType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", zone = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", parseJson = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    const zoneName = zone ? zone === null || zone === void 0 ? void 0 : zone.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_3__/* .SPECIAL_CHAR_REGEX */ .FU, " ") : "zone";
    let internalLinkType = "";
    if (eventLabel === "print") {
        internalLinkType = "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":print");
    } else {
        internalLinkType = "".concat(dataLayerLinkType);
    }
    const internalLinkZoneName = zone ? "".concat(pageType.toLowerCase(), ":").concat(zoneName) : "teaser";
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
        internalLinkZoneName,
        internalLinkURL: "n/a",
        internalLinkName: "".concat(eventLabel),
        eventName: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share")),
        internalLinkType: internalLinkType,
        eventType: eventType,
        eventAction: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share"))
    };
    if (parseJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addDatalayerShare = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "{}", isPdp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const page = window.pageObj || {};
    const eventInfo = JSON.parse(data);
    const dataLayerObj = {
        event: "cmp:click",
        page,
        eventInfo
    };
    if (isPdp) {
        const { productInfo  } = page;
        dataLayerObj["productInfo"] = productInfo;
    }
    window.adobeDataLayer.push(dataLayerObj);
};
const getDownloadEventInfo = function() {
    let downLoadLink = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", pageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", componentPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    let eventInfo = {};
    if (downLoadLink) {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "".concat(downLoadLink),
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":download"),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    } else {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "n/a",
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(dataLayerLinkType),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    }
    return JSON.stringify(eventInfo);
};
const getTitleEventInfo = function() {
    let linkNewTab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", linkURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", pageType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", componentLinkType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", title = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "";
    return '{"clickInternalLinks":"'.concat(linkNewTab || mainTitle.toLowerCase().includes("kohler canada") ? "false" : "true", '","internalLinkPosition":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"teaser","internalLinkURL":"').concat(linkURL || (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getLinkFromHref)(title), '","internalLinkName":"').concat(mainTitle.toLowerCase(), '","eventName":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '","internalLinkType":"').concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase(), '","eventType":"teaser","eventAction":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '"}');
};
const addTeaserActionAnalytics = (param)=>{
    let { pageType ="" , componentPosition ="" , videoTitle ="" , link ="" , text ="" , eventName: eventNameDatalayer , dataLayerLinkType ="" , eventAction: eventActionDataLayer , productCategory ="" , productCollectionsName ="" , productRoom ="" , datalayerPageType ="" , mainTitle ="" , componentInfo =""  } = param;
    const eventTitle = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.makingTextDatalayerReady)(mainTitle);
    let internalLinkZoneName;
    const eventPageType = pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase();
    const linkText = text === null || text === void 0 ? void 0 : text.toLowerCase();
    let eventAction = eventPageType ? "".concat(eventPageType, ":").concat((eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) || eventTitle || "zone", ":").concat(linkText) : "".concat((eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) || eventTitle || "zone", ":").concat(linkText);
    let eventName = eventAction;
    if (videoTitle || eventPageType === "plp") {
        eventAction = "".concat(eventPageType, ":").concat(videoTitle, ":").concat(linkText);
        eventName = "".concat(eventPageType, ":").concat(videoTitle, ":").concat(linkText);
        internalLinkZoneName = "".concat(eventPageType, ":").concat(videoTitle);
    } else if (eventTitle) {
        internalLinkZoneName = "".concat(eventPageType, ":").concat(eventTitle);
    } else {
        internalLinkZoneName = "teaser";
    }
    let internalLinkPosition = eventPageType ? "".concat(eventPageType, ":").concat(componentPosition || "teaser") : componentPosition || "teaser";
    let internalLinkType = videoTitle.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_3__/* .PURE_DATA_FOR_STRING_REGEX */ .YN, "") ? "".concat("".concat(eventPageType, ":").concat(videoTitle.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_3__/* .PURE_DATA_FOR_STRING_REGEX */ .YN, ""))) : eventPageType ? "".concat(eventPageType, ":").concat(eventTitle) : "navigation";
    if (dataLayerLinkType.includes("social impact")) {
        eventName = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        eventAction = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        internalLinkZoneName = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")));
    }
    let eventType = "navigation";
    if (datalayerPageType.includes("locations")) {
        pageType = "locations:kohler stores";
        eventName = "".concat(eventPageType, ":").concat(linkText);
        eventAction = "".concat(eventPageType, ":").concat(linkText);
        internalLinkZoneName = eventPageType;
        internalLinkPosition = "".concat(eventPageType, ":teaser");
        internalLinkType = "".concat(eventPageType, ":").concat(eventTitle);
    }
    const page = window.pageObj || {};
    if ((text === "Get Started" || text === "Apply Now") && eventActionDataLayer === null) {
        var ref, ref1;
        const datalayerPageType1 = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType;
        const NewDatalayerPageType = datalayerPageType1 === "services" ? page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.subCategoryID : datalayerPageType1;
        eventAction = linkText;
        eventName = linkText;
        eventType = "promo banner";
        internalLinkPosition = "".concat(NewDatalayerPageType === null || NewDatalayerPageType === void 0 ? void 0 : NewDatalayerPageType.toLowerCase(), ":promo banner");
        internalLinkType = eventPageType ? "".concat(eventPageType, ":").concat(eventTitle) : "navigation";
        internalLinkZoneName = "".concat(NewDatalayerPageType === null || NewDatalayerPageType === void 0 ? void 0 : NewDatalayerPageType.toLowerCase(), ":promo details");
    }
    if ((linkText === _constants_index__WEBPACK_IMPORTED_MODULE_2__.BROWSE_ALL_KOHLER_STORES || text === _constants_index__WEBPACK_IMPORTED_MODULE_2__.MORE_OPTIONS.LEARN_MORE) && datalayerPageType === "locations") {
        pageType = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.FIND_A_STORE, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.PAGE_TYPES.LOCATION_LANDING_PAGE);
        eventName = "".concat(pageType, ":").concat(linkText);
        eventAction = "".concat(pageType, ":").concat(linkText);
        internalLinkPosition = _constants_index__WEBPACK_IMPORTED_MODULE_2__.FIND_A_STORE;
        internalLinkType = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.FIND_A_STORE, ":").concat(text === _constants_index__WEBPACK_IMPORTED_MODULE_2__.MORE_OPTIONS.LEARN_MORE && eventTitle || eventType);
        internalLinkZoneName = "".concat(pageType).concat(text === _constants_index__WEBPACK_IMPORTED_MODULE_2__.MORE_OPTIONS.LEARN_MORE && ":" + eventTitle || "");
    }
    if (eventPageType === _constants_index__WEBPACK_IMPORTED_MODULE_2__.HOW_TO_BECOME_A_KPN) {
        eventName = "".concat(eventPageType, ":").concat(text === _constants_index__WEBPACK_IMPORTED_MODULE_2__.JOIN_NOW ? _constants_index__WEBPACK_IMPORTED_MODULE_2__.TWO_WAYS_TO_BE_A_KPN : mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase(), ":").concat(linkText);
        eventAction = "".concat(eventPageType, ":").concat(text === _constants_index__WEBPACK_IMPORTED_MODULE_2__.JOIN_NOW ? _constants_index__WEBPACK_IMPORTED_MODULE_2__.TWO_WAYS_TO_BE_A_KPN : mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase(), ":").concat(linkText);
        internalLinkZoneName = "".concat(eventPageType, ":").concat(text === _constants_index__WEBPACK_IMPORTED_MODULE_2__.JOIN_NOW ? _constants_index__WEBPACK_IMPORTED_MODULE_2__.TWO_WAYS_TO_BE_A_KPN : mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase());
        eventType = "teaser";
        internalLinkPosition = "".concat(eventPageType, ":teaser");
    }
    if (window.eventPageType === "pdp" && text === "Shop Farmstead") {
        var ref2, ref3;
        eventName = "".concat((ref2 = window.eventPageType) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), ":farmstead sink:").concat(linkText);
        eventAction = "".concat((ref3 = window.eventPageType) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), ":farmstead sink:").concat(linkText);
        eventType = "navigation";
        internalLinkPosition = "pdp:".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase());
        internalLinkType = "pdp:".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase());
        internalLinkZoneName = _constants_index__WEBPACK_IMPORTED_MODULE_2__.PDP_DETAILS;
    }
    const eventInfo = {
        clickInternalLinks: (link === null || link === void 0 ? void 0 : link.startsWith("/")) || (link === null || link === void 0 ? void 0 : link.startsWith("#")) || (link === null || link === void 0 ? void 0 : link.includes(window.location.hostname)) ? "true" : "false",
        internalLinkPosition,
        internalLinkZoneName,
        internalLinkURL: link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.removeAndCleanLink)(link)) : "n/a",
        internalLinkName: "".concat(!text ? "explore more arrow" : linkText),
        eventName,
        internalLinkType,
        eventType,
        eventAction,
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    const customDataLayer = {
        ...componentInfo ? {
            componentInfo: JSON.parse(componentInfo)
        } : {},
        productInfo: {
            productCategory: productCategory || "n/a",
            productCollectionsName: productCollectionsName || "n/a",
            productRoom: productRoom || "n/a"
        }
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click", {}, customDataLayer);
};
const addTeaserDescriptionAnalytic = function() {
    let target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isPdp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isPlp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", pageType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", internalLinkPositionNotPdp = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", preTitle = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", mainTitle = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", linkURL = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", internalLinkTypeNotPdp = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "", sanitizeDescription = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : "";
    return JSON.stringify({
        clickInternalLinks: target === "_blank" ? "false" : "true",
        internalLinkPosition: isPdp || isPlp ? pageType.toLowerCase() : internalLinkPositionNotPdp,
        internalLinkZoneName: isPlp ? "".concat(pageType.toLowerCase(), ":").concat(preTitle, ":rm") : mainTitle ? "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(mainTitle) : "teaser",
        internalLinkURL: linkURL,
        eventName: isPlp ? "".concat(pageType.toLowerCase(), ":").concat(preTitle, ":rm") : "".concat(pageType.toLowerCase(), ":").concat(mainTitle, ":").concat(sanitizeDescription),
        internalLinkType: isPdp ? "".concat(pageType.toLowerCase(), ":teaser") : isPlp ? "".concat(pageType.toLowerCase(), ":navigation") : internalLinkTypeNotPdp,
        eventType: isPdp || isPlp ? "navigation" : "teaser",
        internalLinkName: sanitizeDescription,
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventAction: isPlp ? "".concat(pageType.toLowerCase(), ":").concat(preTitle, ":rm") : "".concat(pageType.toLowerCase(), ":").concat(mainTitle, ":").concat(sanitizeDescription)
    });
};
const addTeaserAnalytic = function(e) {
    let linkNewTab = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, componentPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", linkURL = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", mainTitle = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", pageType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", componentLinkType = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", title = arguments.length > 7 ? arguments[7] : void 0, datalayerLinkName = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "", containerIdName = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : "", eventName = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : "", eventAction = arguments.length > 11 && arguments[11] !== void 0 ? arguments[11] : "";
    e.preventDefault();
    return '{"clickInternalLinks":"'.concat(linkNewTab ? "false" : "true", '","internalLinkPosition":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"teaser","internalLinkURL":"').concat(linkURL, '","internalLinkName":"').concat(datalayerLinkName, '","eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(containerIdName, ":").concat(eventName || datalayerLinkName || "rm", '","internalLinkType":"').concat(pageType, ":").concat(componentLinkType || mainTitle, '","eventType":"teaser","eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(containerIdName, ":").concat(eventAction || datalayerLinkName || "rm", '"}');
};
const addTeaserLinkAnalytics = (teaserFullData, link, bodytitle, containerId, data, datalayerPageName, linkURL)=>{
    const { datalayerLinkName , fullData , mainTitle , eventAction , eventName , linkNewTab  } = data;
    const { teaser: { pretitle: teaserPretitle = ""  } = {}  } = teaserFullData || {};
    const page = window.pageObj || {};
    const { pageInfo: { pageUrl  } , productInfo  } = page;
    const pageType = window.eventPageType;
    const internalLinkName = (0,_utils_index__WEBPACK_IMPORTED_MODULE_1__.sanitizedTextAndEntities)(datalayerLinkName);
    if (pageType === "pdp") {
        var ref, ref1, ref2, ref3, ref4;
        const eventInfo = {
            eventAction: "pdp:".concat((fullData === null || fullData === void 0 ? void 0 : (ref = fullData.teaser) === null || ref === void 0 ? void 0 : ref.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref1 = fullData.teaser) === null || ref1 === void 0 ? void 0 : ref1.mainTitle : "product details", ":").concat((0,_utils_index__WEBPACK_IMPORTED_MODULE_1__.sanitizedTextAndEntities)(eventAction || mainTitle).toLowerCase().trim()),
            eventName: "pdp:".concat((fullData === null || fullData === void 0 ? void 0 : (ref2 = fullData.teaser) === null || ref2 === void 0 ? void 0 : ref2.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref3 = fullData.teaser) === null || ref3 === void 0 ? void 0 : ref3.mainTitle : "product details", ":").concat((0,_utils_index__WEBPACK_IMPORTED_MODULE_1__.sanitizedTextAndEntities)(eventName || mainTitle).toLowerCase().trim()),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:teaser",
            internalLinkZoneName: "pdp:".concat((0,_utils_index__WEBPACK_IMPORTED_MODULE_1__.sanitizedTextAndEntities)((fullData === null || fullData === void 0 ? void 0 : (ref4 = fullData.teaser) === null || ref4 === void 0 ? void 0 : ref4.mainTitle) || bodytitle).toLowerCase().trim()),
            internalLinkURL: "".concat(window.location.href || link || pageUrl || "n/a"),
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
        };
        const dataLayerObj = {
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        };
        window.adobeDataLayer.push(dataLayerObj);
    } else if (pageType === _constants_index__WEBPACK_IMPORTED_MODULE_2__.INSPIRATION_PAGE_NAME.KIPS_BAY_DECORATOR) {
        var ref5, ref6, ref7, ref8, ref9;
        const eventInfo1 = {
            eventAction: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref5 = fullData.teaser) === null || ref5 === void 0 ? void 0 : ref5.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref6 = fullData.teaser) === null || ref6 === void 0 ? void 0 : ref6.mainTitle : containerId.replaceAll("-", " "), ":").concat(eventAction || mainTitle),
            eventName: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref7 = fullData.teaser) === null || ref7 === void 0 ? void 0 : ref7.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref8 = fullData.teaser) === null || ref8 === void 0 ? void 0 : ref8.mainTitle : containerId.replaceAll("-", " "), ":").concat(eventName || mainTitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(datalayerLinkName),
            internalLinkPosition: "".concat(pageType, ":teaser"),
            internalLinkType: "".concat(pageType, ":").concat(containerId.replaceAll("-", " ")),
            internalLinkZoneName: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref9 = fullData.teaser) === null || ref9 === void 0 ? void 0 : ref9.mainTitle) || containerId.replaceAll("-", " ")),
            internalLinkURL: "".concat(window.location.href || link || pageUrl || "n/a"),
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
        };
        const dataLayerObj1 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo1
        };
        window.adobeDataLayer.push(dataLayerObj1);
    } else if (pageType === "home with shea mcgee") {
        const linkPosition = datalayerPageName.split(":")[0];
        const eventInfo2 = {
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true"),
            internalLinkPosition: linkPosition,
            eventMsg: "n/a",
            internalLinkZoneName: "".concat(pageType, ":").concat(linkURL),
            internalLinkURL: "".concat(linkURL),
            internalLinkName: mainTitle,
            internalLinkType: "".concat(linkPosition, ":").concat(pageType),
            eventType: "navigation",
            eventAction: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle),
            eventName: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle)
        };
        const dataLayerObj2 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo2
        };
        window.adobeDataLayer.push(dataLayerObj2);
    } else if ((pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase()) === _constants_index__WEBPACK_IMPORTED_MODULE_2__.INSPIRATION_PAGE_NAME.PROJECT_GALLERY) {
        addProjectGalleryAnalytics(linkNewTab, pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), linkURL === null || linkURL === void 0 ? void 0 : linkURL.toLowerCase(), link, mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase(), teaserPretitle === null || teaserPretitle === void 0 ? void 0 : teaserPretitle.toLowerCase());
    } else if (pageType === "plp") {
        var ref10;
        const preTitle = (ref10 = document.querySelector(".cmp-teaser__pretitle p")) === null || ref10 === void 0 ? void 0 : ref10.textContent.toLowerCase();
        const eventInfo3 = {
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true"),
            internalLinkPosition: pageType,
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkZoneName: "".concat(pageType, ":").concat(linkURL),
            internalLinkURL: "".concat(window.location.origin).concat(link),
            internalLinkName: mainTitle,
            internalLinkType: "".concat(pageType, ":").concat(preTitle, ":").concat(linkURL),
            eventType: "carousel",
            eventAction: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle),
            eventName: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle)
        };
        const dataLayerObj3 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo3
        };
        window.adobeDataLayer.push(dataLayerObj3);
    } else {
        var ref11, ref12, ref13;
        const eventNameAction = "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref11 = fullData.teaser) === null || ref11 === void 0 ? void 0 : ref11.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref12 = fullData.teaser) === null || ref12 === void 0 ? void 0 : ref12.mainTitle : containerId.replaceAll("-", " "), ":").concat(eventAction || mainTitle);
        const eventInfo4 = {
            eventAction: eventNameAction.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_3__/* .QUOT_REGEX */ .RR, ""),
            eventName: eventNameAction.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_3__/* .QUOT_REGEX */ .RR, ""),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(datalayerLinkName).replace(_constants_regex__WEBPACK_IMPORTED_MODULE_3__/* .QUOT_REGEX */ .RR, ""),
            internalLinkPosition: "".concat(pageType, ":teaser"),
            internalLinkType: "".concat(pageType, ":").concat(containerId.replaceAll("-", " ")),
            internalLinkZoneName: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref13 = fullData.teaser) === null || ref13 === void 0 ? void 0 : ref13.mainTitle) || containerId.replaceAll("-", " ")),
            internalLinkURL: "".concat(window.location.href || link || pageUrl || "n/a"),
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
        };
        const dataLayerObj4 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo4
        };
        window.adobeDataLayer.push(dataLayerObj4);
    }
};
const addProjectGalleryAnalytics = (linkNewTab, page, teaserTitle, linkUrl, mainTitle, teaserPretitle)=>{
    const title = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.makingTextDatalayerReady)(mainTitle);
    const eventInfo = {
        clickInternalLinks: "".concat(linkNewTab ? "false" : "true"),
        internalLinkPosition: "".concat(page, ":teaser"),
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkZoneName: "".concat(page, ":").concat(teaserPretitle || teaserTitle),
        internalLinkURL: "".concat(window.location.origin).concat(linkUrl),
        internalLinkName: title,
        internalLinkType: "".concat(page, ":").concat(teaserTitle),
        eventType: "navigation",
        eventAction: "".concat(page, ":").concat(teaserPretitle || teaserTitle, ":").concat(title),
        eventName: "".concat(page, ":").concat(teaserPretitle || teaserTitle, ":").concat(title)
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
};


/***/ })

}]);